
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAutomationBadge as ObcAutomationBadgeElement} from '@oicl/openbridge-webcomponents/dist/automation/automation-badge/automation-badge.js';
 
 
 

 
 export const ObcAutomationBadge = createComponent({
   react: React,
   tagName: 'obc-automation-badge',
   elementClass: ObcAutomationBadgeElement,
   events: {
     
   }
  });
 
 